(function () {
    function SoliaPage() {
        return (React.createElement("div", null,
            React.createElement(Hero, null),
            React.createElement(Marquee, null),
            React.createElement(StoryScroll, null),
            React.createElement(Anatomy, null),
            React.createElement(FlavorSwitcher, null),
            React.createElement(Reviews, null),
            React.createElement(FinalCTA, null)));
    }
    ReactDOM.createRoot(document.getElementById('solia-home-root')).render(React.createElement(SoliaPage, null));
})();
